import * as types from '../../mutationTypes';
import { VIEW_TYPES } from '../../../constants';

export default {
  /* eslint-disable no-param-reassign */
  [types.RESET_AUTHORISATION](state) {
    // CSAdmin = 4, GroupAdmin = 3, ClientAdmin = 2, ClientUser = 1, NotAuthenticated = 0
    state.role = 0;
    state.originalAdminRole = 0;
    state.siteType = 0;
    state.viewType = VIEW_TYPES.CLIENT;
    /**
     * featureToggle.clientModule is getting data from AWS S3 client module toggle list.
     * so clientModule is reserved.
     * We can add more attribute to featureToggle for feature toggle (e.g auditLog)
     * when we need new show
     * or hide our WIP features.
     */
    state.draftMode = false;
  },

  [types.SET_ROLE](state, value) {
    let role = value;
    if (Number.isNaN(Number(value))) role = 1;
    state.role = role;
  },

  [types.SET_ORIGINAL_ADMIN_ROLE](state, value) {
    let originalAdminRole = value;
    if (Number.isNaN(Number(value))) originalAdminRole = 1;
    state.originalAdminRole = originalAdminRole;
  },

  [types.SET_SITE_TYPE](state, value) {
    state.siteType = value;
  },

  [types.SET_DRAFT_MODE](state, value) {
    state.draftMode = !!value;
  },

  [types.SET_VIEW_TYPE](state, value) {
    state.viewType = value;
  }
  /* eslint-enable no-param-reassign */
};
